module.exports = __webpack_public_path__ + "img/gumayajayd.9c2229d8.jpg";